import { ChangeDetectionStrategy, Component, computed, effect, input, InputSignal, Signal, signal, WritableSignal } from '@angular/core';

@Component({
  selector: 'ui-text-expandable',
  templateUrl: './text-expandable.component.html',
  styleUrl: './text-expandable.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextExpandableComponent {
  private readonly modifiedMaxTextLength: WritableSignal<number> = signal(200);

  public readonly text: InputSignal<string> = input.required();
  public readonly maxTextLength: InputSignal<number> = input(200);
  public readonly expandLabel: InputSignal<string> = input('Ausklappen');

  public readonly trimmedText: WritableSignal<string> = signal('');
  public readonly showExpandedText: WritableSignal<boolean> = signal(false);
  public readonly showExpandButton: Signal<boolean> = computed(() => this.text().length > this.modifiedMaxTextLength());

  public constructor() {
    effect(() => {
      const text: string = this.text();
      const maxTextLength: number = this.maxTextLength();

      this.modifiedMaxTextLength.set(maxTextLength);

      if (text.length <= maxTextLength) {
        this.trimmedText.set(text);

        return;
      }

      if (text[maxTextLength] === ' ') {
        this.trimmedText.set(text.substring(0, maxTextLength));
      } else {
        for (let i: number = maxTextLength; i < text.length; i++) {
          if (text[i] === ' ') {
            this.modifiedMaxTextLength.set(i);
            this.trimmedText.set(text.substring(0, i));

            return;
          }
        }

        this.trimmedText.set(text);
        this.modifiedMaxTextLength.set(text.length);
      }
    });
  }

  public toggleExpanded(): void {
    this.showExpandedText.set(!this.showExpandedText());
  }
}
